// List all the commands
const commandModules = import.meta.glob("./*/index.jsx", { eager: true });

// This is also the order of the dropdown menu
const commandFolderList = [
    "CommandScanArea",
    "CommandFlyToWaypoint",
    "CommandWaitForPeriod",
    "CommandTakePicture",
    "CommandSetPayloadRecording",
    "CommandSetPictureDistance",
    "CommandSetSpeedXY",
    "CommandEndFlight",
    "CommandMoveXYZ",
    "CommandFlyToXY",
    "CommandFlyToZ",
    "CommandFlyToYaw",
];

export const commandInfo = commandFolderList.reduce((acc, folderName) => {
    const globKey = `./${folderName}/index.jsx`;
    const moduleNamespace = commandModules[globKey];
    if (!moduleNamespace) {
        console.warn(`Missing module: ${globKey}`);
        return acc;
    }
    const commandType = moduleNamespace.commandType;
    if (!commandType) {
        console.warn(`Module ${globKey} did not export commandType.`);
        return acc;
    }

    acc[commandType] = { ...moduleNamespace };
    return acc;
}, {});

export function canEditTaskWithCommands(
    commands,
    userIsAdmin,
    resourceOrganizationId,
) {
    return commands.every((command) => {
        return canUseCommand(
            commandInfo[command.type],
            userIsAdmin,
            resourceOrganizationId,
        );
    });
}

export function canUseCommand(info, userIsAdmin, resourceOrganizationId) {
    // Admin-only commands can be used by admins or for explicitly opted-in resource organizations.
    return !(
        info?.isAdminOnly &&
        !userIsAdmin &&
        !info?.organizations?.includes(resourceOrganizationId)
    );
}
